const state = {
  total_count: 0,
  team_list: [{
    slug: '',
    title: '',
    county_name: '',
    gender: 'male',
    create_date: '',
    category: 0,
    category_title: '',
    member_count: 0,
    min_count: 0,
    max_count: 0,
    logo_url: '',
    editable: false,
    can_complete: false,
  }],
  team: {
    slug: '',
    title: '',
    logo_url: '',
    county: 0,
    county_name: '',
    category: 0,
    category_title: '',
    gender: 'male',
    custom_input: '',
    custom_text: '',
    custom_file: null,
    custom_input_title: '',
    custom_text_title: '',
    custom_file_title: '',
    is_global: false,
    is_active: false,
    is_incomplete: false,
    can_see: true,
    can_edit_team: false,
    can_edit_members: false,
    can_edit_input: false,
    can_edit_text: false,
    can_edit_file: false,
    create_date: '',
    category_is_active: false,
    min_count: 0,
    max_count: 0,
    photo_url: '',
    members: [{slug: '', full_name: '', role_title: '', create_date: ''}]
  },
  active_category_list: [],
  active_county_list: [],
}

const getters = {
  TeamTotalCount: state => state.total_count,
  TeamList: state => state.team_list,
  Team: state => state.team,
  ActiveCategoryList: state => state.active_category_list,
  ActiveCountyList: state => state.active_county_list,
}

const mutations = {
  setTeamList(state, payload) { state.team_list=payload.list; state.total_count=payload.total_count },
  setTeamListPush(state, payload) { state.team_list=state.team_list.concat(payload.list); state.total_count=payload.total_count },
  setCategoryAndCountyList(state, payload) { state.active_category_list=payload.active_category_list; state.active_county_list=payload.active_county_list },
  setTeamTitle(state, payload) { state.team_list[state.team_list.map(item => item.slug).indexOf((payload.slug))].title=payload.title },
  setTeamRemove(state, payload) { state.team_list.splice(state.team_list.map(item => item.slug).indexOf(payload.slug),1); state.total_count-=1; },
  setNewTeamInTeamList(state, payload) { state.team_list.push(payload); state.total_count+=1; },
  setTeam(state, payload) { state.team=payload },
  setTeamUpdate(state, payload) { state.team.custom_input=payload.input; state.team.custom_text=payload.text; state.team.custom_file=payload.file },
  setRemoveMemberInTeam(state, payload) { state.team.members.splice(state.team.members.map(item => item.slug).indexOf(payload),1) },
  setNewMemberInTeam(state, payload) { state.team.members.push(payload) },
}

const actions = {
}

export default {
  state,
  getters,
  mutations,
  actions
}
